module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_auerbach_sm-f003ca59d9dbd1748d943dbf11c17bf0.png";